import { useQuery } from '@tanstack/react-query';
import { activityService } from '@/services/features/ActivityService';
import { useAuth } from '@/contexts/AuthContext';

export const useActivityAuditLog = (activityId: number | null) => {
  const { hasuraToken } = useAuth();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['activityAuditLog', activityId],
    queryFn: async () => {
      if (!activityId || !hasuraToken) {
        return { logs: [], totalCount: 0 };
      }
      return activityService.getActivityAuditLog(activityId, hasuraToken);
    },
    enabled: !!activityId && !!hasuraToken,
  });

  return {
    activityAuditLogs: data?.logs || [],
    totalCount: data?.totalCount || 0,
    auditLogsLoading: isLoading,
    error,
    refetch,
  };
};
